import React, { useState } from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'
import { Empty, message } from 'antd'
import moment from 'moment'

import CustomersReportTopBar from './partials/CustomersReportTopBar'
import CustomersReportContent from './partials/CustomersReportAgeContent'
import CustomersReportForm from './partials/CustomersReportForm'

import { customersSegmentByAgeRangeReport } from './services'
import { handleError } from '../../helpers'

export default function SegmentByAgeRange() {
	const [report, setReport] = useState(null)
	const [loading, setLoading] = useState(false)
	const [params, setParams] = useState({ 
		from: moment().startOf('month').format('YYYY-MM-DD').toString(),
		until: moment().endOf('month').format('YYYY-MM-DD').toString()
	})

	const onSubmit = () => {
		if(!params.from || !params.until) 
			return message.warning('Debe ingresar unas fechas correctas')

		setLoading(true)
		customersSegmentByAgeRangeReport(params)
			.then(res => setReport(res.data))
			.catch(error => handleError(error))
			.finally(() => setLoading(false))
	}

	return (
		<React.Fragment>
			<CustomersReportTopBar 
				title="Segmentos por rango de edad"
				subtitle="Ver segmentos de clientes por rango de edad"
			/>
			<Row>
				<Col lg="3" md="4">
					<CustomersReportForm
						report={report}
						params={params}
						setParams={setParams}
						onSubmit={onSubmit}
						loading={loading}
					/>
				</Col>
				<Col>
					<Card>
						<CardBody>
							{ report ? (
								<CustomersReportContent 
									report={report}
									loading={loading}
								/>
							) : (
								<Empty description="Aún no ha generado el reporte" />
							)}
						</CardBody>
					</Card>
				</Col>
			</Row>
		</React.Fragment>
	)
}